/**
 * Core
 */
import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";
import { validateName, simplyClick } from "../../helpers";
import ButtonGroup from "../ButtonGroup";
import InputGlobal from "../InputGlobal";

/**
 *Styles
 */
import "./Name.scss";
import { errorEventsName } from "../../constants";
import Tooltip from "../Tooltip";

const Name = ({ setStep, step }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorName, setErrorName] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleOptionChange = (e) => {
    const val = e.target.value;
    setSelectedOption(val);

    if (val === "option1") {
      simplyClick("cl_lnd_cd3_our_members_yes", null);
    } else if (val === "option2") {
      simplyClick("cl_lnd_cd3_our_members_skip", null);
    }
  };
  const handlerSubmit = () => {
    const { status, error = { text: "", type: "" } } = validateName(
      data?.first_name ?? ""
    );

    if (error.type) {
      simplyClick(errorEventsName[error.type]);
    }

    if (status) {
      simplyClick("cl_lnd_cd3_want_member_next");
      simplyClick("cl_lnd_cd3_want_member_type_name", {
        first_name: data?.first_name,
      });
      setStep(step + 1);
    } else {
      setErrorName(error.text);
    }
  };

  const handleChangeName = ({ target: { value } }) => {
    setErrorName(null);
    setShowTooltip(false);
    setData({ ...data, first_name: value });
  };
  const handlerStepBack = () => {
    simplyClick("cl_lnd_cd3_want_member_back");
    setStep(step - 1);
  };

  const handlerNameFocus = () => {
    setShowTooltip(true);
    simplyClick("cl_lnd_cd3_want_member_type_name");
  };
  return (
    <div className="global__form-wrap">
      <div className="name__form">
        <h5 className="form__title">
          Our members are seeking to connect with people from all over the world
          and have some fun. Does that sound like what you’re looking for?
        </h5>
        <div className="radio__wrap">
          <label className="yes">
            <input
              type="radio"
              value="option1"
              onChange={handleOptionChange}
              checked={selectedOption === "option1"}
            />
            <span
              className={
                "custom-radio yes " +
                (selectedOption === "option1" ? "checked" : "")
              }
            ></span>
            Yes
          </label>
          <label className="skip">
            <input
              type="radio"
              value="option2"
              onChange={handleOptionChange}
              checked={selectedOption === "option2"}
            />
            <span
              className={
                "custom-radio skip " +
                (selectedOption === "option2" ? "checked" : "")
              }
            ></span>
            Skip
          </label>
        </div>
        <span className="line" />
        <h5 className="form__title">
          What do you want other members to call you?*
        </h5>
        <p className="name__text">
          You don’t have to use your real name – feel free to use a nickname.
          You can change it anytime.
        </p>
        <div className="name__input">
          <div className="has-float-label">
            <InputGlobal
              className={"input__global" + (errorName ? " error" : "")}
              onChange={(e) => handleChangeName(e)}
              name={"name"}
              placeholder={"Enter your name or nickname"}
              type={"text"}
              id={"name__30"}
              value={data.first_name ? data.first_name : ""}
              autoComplete={"name"}
              onFocus={handlerNameFocus}
              onBlur={() => setShowTooltip(false)}
            />
            <label htmlFor="name__30" className={errorName ? "error" : ""}>
              Enter your name or nickname
            </label>
            {errorName && <p className="error-text">{errorName}</p>}
            <Tooltip
              text="Your name must contain at least 2 Latin letters. Special characters and numbers are not allowed."
              showTooltip={showTooltip}
            />
          </div>
        </div>
      </div>
      <ButtonGroup cbStepNext={handlerSubmit} cbStepBack={handlerStepBack} />
    </div>
  );
};

export default Name;
